import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { Layout } from '@singularsystems/neo-canvas-grid';
import InstrumentsNeedingEnrichmentReportCriteria from "./InstrumentsNeedingEnrichmentReportCriteria";

@NeoReport("InstrumentsNeedingEnrichment", { category: MaintenanceReportCategories.DataEnrichmentReports}) 
export default class InstrumentsNeedingEnrichmentReport extends Report<InstrumentsNeedingEnrichmentReportCriteria> {

    constructor() {
        super(InstrumentsNeedingEnrichmentReportCriteria)
    }

    public renderCriteria() {
        return <></>
    }
    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}